export default __webpack_public_path__ + "9aed96a712d5d361da3d5541be2d7989.png";